import React from 'react';

interface LoadingStateProps {
  text?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  text = 'Loading...',
}) => {
  return (
    <div className="flex-1 overflow-y-auto bg-white p-4 dark:bg-gray-900">
      <div className="mx-auto max-w-4xl">
        <div className="flex flex-col items-center justify-center py-12">
          <div className="mb-3 h-6 w-6 animate-spin rounded-full border-2 border-orange-500 border-t-transparent" />
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {text}
          </span>
        </div>
      </div>
    </div>
  );
};
